import React, { useState } from "react";
import data from "../../json/Aboutus/Leadership.json";
import Modal from "../Modal";
import { Link } from "react-router-dom";
import parse from "html-react-parser";

const Leadership = () => {
  const [showModal, setShowModal] = useState(false);
  const [leader, setLeader] = useState(1);

  const toggleModal = (i) => {
    setShowModal(!showModal);
    setLeader(data.Team[i]);
  };

  return (
    <div className="flex w-full justify-center business">
      <div className="2xl:container  px-6 md:px-10 lg:px-20  w-full flex flex-col items-center py-12 sm:py-16 lg:py-20">
        <div className="w-full flex justify-center">
          <h2 className="text-24 sm:text-32 lg:text-48 text-primarycolor font-semibold max-sm:text-center">{parse(data.Title)}</h2>
        </div>
        <div className="w-full grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mt-10 md:mt-16">
          {data.Team.map((mem, i) => (
            <div key={i} className="flex flex-row md:flex-col w-full h-full">
              <div className="w-full h-full flex flex-row md:flex-col p-4 md:px-5 md:py-10 md:gap-10 border-[1px] border-gray shadow-services justify-start items-center bg-white gap-3 rounded-[12px] md:rounded-[24px]">
                <img
                  className="h-[80px] w-[80px] md:h-[100px] md:w-[100px]"
                  src={process.env.PUBLIC_URL + mem.img}
                  alt={`${mem.name}_pic`}
                />
                <div className="flex flex-col gap-2 md:gap-3 items-left md:items-center w-full">
                  <h2 className="text-18 sm:text-20 font-semibold text-primarycolor">
                    {mem.name}
                  </h2>
                  <p className="text-14 md:text-center md:text-18 text-secondaryblack">{mem.desig}</p>
                  <button
                    onClick={() => toggleModal(i)}
                    className="text-14 hover:text-btnhover  md:text-18 w-full text-left md:text-center bio mt-1 md:mt-3 font-semibold text-ctaorange"
                  >
                    Read Bio
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <Modal show={showModal} onClose={toggleModal}>
          <div className="flex flex-col md:flex-row gap-5 md:gap-10">
            {leader && (
              <div className="p-3 flex flex-col gap-12">
                
                <div className="w-full flex flex-col gap-4 md:gap-8 max-h-[350px] modal-scroll overflow-auto ">
                  <p className="text-16 text-primarycolor  text-justify">
                    {leader.Detail}
                  </p>
                  {/* <Link className="bio font-medium">LinkedIn</Link> */}
                </div>
                <div className="w-[80%] flex flex-col">
                  {/* <img
                    src={process.env.PUBLIC_URL + leader.img}
                    alt="profilepic"
                    className="h-[100px] w-[100px] md:h-[187px] md:w-[187px]"
                  /> */}
                  <h2 className=" text-primarycolor text-20 font-semibold">
                    {leader.name}
                  </h2>
                  <p className=" text-16 text-secondaryblack">
                    {leader.desig}
                  </p>
                </div>
              </div>
            )}
          </div>
        </Modal>
      </div>
    </div>
  );
};

export default Leadership;


// {
//       "img": "/images/Aboutus/leader3.jpg",
//       "name": "Mr. Balaji V Thesma",
//       "desig": "Director - IT and Software",
//       "Detail": "Balaji has over 20+ years of experience in IT industry. Prior to joining USR Systems as CTO, Balaji was CEO of a small business IT services company that focuses on independent testing specializing on mobility and games testing.Starting his career as a team member in one of India’s largest IT services company, Balaji has always been very focused on technology, its evolution and working to create forward looking technology solutions. With Process Automation as the key area of interest, he was the prime author of Y2K tools during the Y2K times that analyzed and made Y2K compliant, several thousands of lines of code automatically. With code generation and testing toeing the lines of automation, he moved into helping customers build automation solutions for testing applications, in a career that spans across the large, medium and small sized IT services companies. Balaji is now focusing on building mobile applications and test automation services for the customers of USR Systems. He also envisions moving USR Systems into building service lines in the areas of AI & ML, IOT and Cyber security."
//     },